export default __webpack_public_path__ + "static/media/01.351c4b17.jpg";